import React from 'react';
import firebase from '../../firebase';
import { connect } from 'react-redux';
import { setCurrentChannel, setPrivateChannel, setExplorePage } from '../../actions';
import { Menu } from 'semantic-ui-react';
import starIcon from '../Images/starIcon.png';

class Starred extends React.Component {
    state = {
        user: this.props.currentUser,
        usersRef: firebase.database().ref('allUsers'),
        activeChannel: '',
        starredChannels: []
    };

    componentDidMount() {
        if (this.state.user) {
            this.addListeners(this.state.user.uid);
        }
    }

    componentWillUnmount() {
        this.removeListener();
    }

    removeListener = () => {
        this.state.usersRef.child(`${this.state.user.uid}/starred`).off();
    }

    addListeners = userId => {
        this.state.usersRef
            .child(userId)
            .child('starred')
            .on('child_added', snap => {
                const starredChannel = { id: snap.key, ...snap.val() };
                this.setState({
                    starredChannels: [...this.state.starredChannels, starredChannel]
                });
            });

        this.state.usersRef
            .child(userId)
            .child('starred')
            .on('child_removed', snap => {
                const channelToRemove = { id: snap.key, ...snap.val() };
                const filteredChannels = this.state.starredChannels.filter(channel => {
                    return channel.id !== channelToRemove.id;
                });
                this.setState({ starredChannels: filteredChannels });
            })
    }

    setActiveChannel = channel => {
        this.setState({ activeChannel: channel.id});
    };

    changeChannel = channel => {
        this.setActiveChannel(channel);
        this.props.setCurrentChannel(channel);
        this.props.setPrivateChannel(false);
        this.props.setExplorePage(false);
    };

    displayChannels = starredChannels => 
    starredChannels.length > 0 && starredChannels.map(channel => (
            <div className="channelText">
            <Menu.Item
                key={channel.id}
                onClick={() => this.changeChannel(channel)}
                name={channel.name}
                active={channel.id === this.state.activeChannel}
            >
                <div
                style={{ display: 'flex', alignItems: 'center',
                        fontFamily: 'proxima-nova, sans-serif',
                        fontWeight: 500,
                        fontStyle: 'normal',
                        fontSize: '14px',
                        marginTop: '3.75px'
                        }}>
                <div 
                className="channelCircleShape"
                style={{
                    width: '9px',
                    height: '9px',
                    backgroundColor: '#fff',
                    borderRadius: '50px',
                }} /> &nbsp;&nbsp;&nbsp;{channel.name}
                </div>
            </Menu.Item>
            </div>
        ));

    render() {
        const { starredChannels } = this.state;

        return (
            <Menu.Menu className="channelMenuSections">
                <Menu.Item className="channelMenuItem" style={{color: '#fff', paddingBottom: '16px', marginLeft: '-10px'}}>
                    <span className="channelSpan" 
                        style={{ 
                        fontFamily: 'proxima-nova, sans-serif',
                        fontWeight: 500,
                        fontStyle: 'normal',
                        color: '#fff' }}>
                        <img src={starIcon} alt="Icon" className="channelIcon" />&nbsp;&nbsp;STARRED ({ starredChannels.length })
                    </span>
                </Menu.Item>
                <div style={{ textTransform: 'lowercase' }}>
                {this.displayChannels(starredChannels)}
                </div>
            </Menu.Menu>
        );
    }
}

const mapStateToProps = state => ({
    currentUser: state.user.currentUser
});

export default connect(mapStateToProps, { setCurrentChannel, setPrivateChannel, setExplorePage })(Starred);


// WEBPACK FOOTER //
// ./src/components/SidePanel/Starred.js